module.exports = __webpack_public_path__ + "static/media/Beheeyem_gaussian2.cc0d5a21.png";